const rebateStatusEnum = {
  Active: 0,
  Inactive: 1,
  Draft: 2,
  Live: 3,
  WaitingForApproval: 4,
}

export default { rebateStatusEnum }
